import {
  GOVERNANCE_DECISION_JOURNEY_STAGES,
  getGovernanceDecisionJourneyStage,
} from './governanceDecisionJourney'

export default function GovernanceDecisionJourney({ currentStage }) {
  const current = getGovernanceDecisionJourneyStage(currentStage)

  if (!current) throw new Error(`Unknown governance decision journey stage: ${currentStage}`)

  const stageNumber = GOVERNANCE_DECISION_JOURNEY_STAGES.indexOf(current) + 1

  return <section aria-labelledby="governance-decision-journey-heading" className="min-w-0">
    <h2 id="governance-decision-journey-heading" className="text-[11px] font-medium uppercase tracking-[0.2em] text-slate-400">Governance Journey</h2>
    <ol className="mt-2 hidden min-w-0 items-center gap-2 text-sm text-slate-500 sm:flex">
      {GOVERNANCE_DECISION_JOURNEY_STAGES.map((stage, index) => {
        const isCurrent = stage.id === currentStage
        return <li className="flex min-w-0 items-center gap-2" key={stage.id}>
          {index > 0 && <span aria-hidden="true" className="text-slate-300">›</span>}
          <span className={isCurrent ? 'font-semibold text-emerald-700' : 'font-medium text-slate-500'} title={stage.module}>
            {isCurrent ? `${stage.label} — Current` : stage.label}
          </span>
        </li>
      })}
    </ol>
    <p className="mt-1.5 text-sm font-medium text-slate-600 sm:hidden">
      <span className="text-emerald-700">{current.label} — Current</span>
      <span aria-hidden="true" className="px-1.5 text-slate-300">·</span>
      <span>Stage {stageNumber} of {GOVERNANCE_DECISION_JOURNEY_STAGES.length}</span>
    </p>
  </section>
}
